angular.module('controllers').controller('statisticController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$http', '$route', '$routeParams', '$location', '$timeout', '$interval', '$window',
  function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $http, $route, $routeParams, $location, $timeout, $interval, $window) {

    $rootScope.path = '/statistic';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'statistic';
		$scope.pathTemplate = 'statistics';
		$scope.title = 'Statistici';
    $rootScope.typeId = 'id';
    $scope.defaultItem = 10;

		angular.extend(this, $controller('crudController', {$scope: $scope}));

    $scope.additionals['publicPath'] = '/images/app';
    $scope.additionals['jsonPath'] = '/json';

    $scope.maxDate = new Date();
    $scope.minDate = '2010-01-01';
    var current_init_date = new Date();
    current_init_date.setHours(0, 0, 0, 0);
    $scope.search.dateTo = current_init_date;
    //$scope.search.dateFrom =  new Date('2022-07-13');

    $scope.printReport = $window;
    $scope.isLoadingPrinter = false;
    $scope.printPreview = function (ev, path, availableColumns, columns) {
        $scope.isLoadingPrinter = true;
        var popup = $scope.printReport.open('', '_blank', 'width=800,height=300,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no,top=50');
        popup.document.open();

        Crud.search($scope.search, path, 1, 'p')
            .success(function (data) {
                $scope.isLoadingPagination = false;
                $scope.isLoadingPrinter = false;

                $scope.additionals['buttonDisabledPagination'] = false;
                var printColumns = {};
                if (!angular.isUndefined(availableColumns) && availableColumns.length > 0) {
                    angular.forEach(columns, function (item, index) {
                        if (availableColumns.indexOf(index) >= 0) {
                            printColumns[index] = item;
                        }
                    });
                } else {
                    printColumns = columns;
                }
                var title = 'Raport ';
                if($scope.search['reportType'] == 'reportDetail') {
                    title = title + 'detaliat';
                }
                if($scope.search['reportType'] == 'reportStatisticTotalOrder') {
                    title = title + 'statistic pe comenzi';
                }
                if($scope.search['reportType'] == 'reportStatisticShippingOrder') {
                    title = title + 'statistic cumulativ in functie de metoda de livrare';
                }
                if($scope.search['reportType'] == 'reportStatisticSourceOrder') {
                    title = title + 'statistic pe surse de provenienta';
                }
                if($scope.search['reportType'] == 'reportStatisticDiscountOrder') {
                    title = title + 'statistic reduceri';
                }
                if($scope.search['reportType'] == 'reportStatisticDeliveryTimeDriver') {
                    title = title + 'statistic timp mediu de livrare';
                }

                title = title + '  ';
                if ($scope.search['dateFrom']) {
                    title = title + moment($scope.search['dateFrom']).format('DD/MM/YY');
                }
                if ($scope.search['timeFrom']) {
                    title = title + moment($scope.search['timeFrom']).format(' HH:mm:ss');
                }
                if ($scope.search['dateFrom'] || $scope.search['timeFrom']) {
                    title = title + '   ';
                }
                if ($scope.search['dateTo']) {
                    title = title + moment($scope.search['dateTo']).format('DD/MM/YY');
                }
                if ($scope.search['timeTo']) {
                    title = title + moment($scope.search['timeTo']).format(' HH:mm:ss');
                }

                var html = '<div class="report-print">';
                var orders = data.data;
                if (orders.length > 0) {
                    html = html + '<table><tr>';
                    html = html + '<th>Nr.</th>';
                    angular.forEach(printColumns, function (itemColumn, keyColumn) {
                        if(!itemColumn['nonDisplay']) {
                            html = html + '<th>' + itemColumn['label'] + '</th>';
                        }
                    });
                    html = html + '</tr>';

                    var nos_orders = 0;
                    var nos_slots = 0;
                    var values_orders = 0;
                    var shipping_values_orders = 0;
                    var discount_values_orders = 0;

                    var shipping_no_orders_1 = 0;
                    var shipping_no_orders_2 = 0;
                    var shipping_value_orders_1 = 0;
                    var shipping_value_orders_2 = 0;

                    if (!angular.isUndefined($scope.order_source)){
                      angular.forEach($scope.order_source.options, function (itemSource, indexSource) {
                         if(indexSource != '' && itemSource['id'] != 3){
                           window['source_no_orders_'+itemSource.id] =  0;
                           window['source_value_orders_'+itemSource.id] = 0;
                         }
                      });
                    }

                    if (!angular.isUndefined($scope.discounts)){
                      angular.forEach($scope.discounts, function (itemDiscount, indexDiscount) {
                           window['discount_no_orders_'+itemDiscount.id] =  0;
                           window['discount_value_orders_'+itemDiscount.id] = 0;
                      });
                    }

                    angular.forEach(orders, function (item, key) {
                        html = html + '<tr>';
                        var keys = key + 1;
                        html = html + '<td>' + keys + '</td>';
                        angular.forEach(printColumns, function (itemColumn, keyColumn) {
                            if(!itemColumn['nonDisplay']) {
                                if (itemColumn['filterType'] == 'select') {
                                    if (!angular.isUndefined(item[keyColumn]) && item[keyColumn] != '') {
                                        html = html + '<td>' + $scope.additionals['associativeColumn'](printColumns[keyColumn], item[keyColumn]) + '</td>';
                                    } else {
                                        html = html + '<td></td>';
                                    }
                                } else {
                                    if (!angular.isUndefined(item[keyColumn]) && item[keyColumn] != '') {
                                        if(keyColumn == 'drivers'){
                                          var div_driver = '';
                                          angular.forEach(item[keyColumn], function (itemDriver, keyDriver) {
                                             div_driver = div_driver + '<div>' + itemDriver['driver_name'] +'   '+ $scope.additionals['formatTime'](itemDriver['value_delivery_time']) + '</div>';
                                          });
                                          html = html + '<td>' + div_driver + '</td>';
                                        } else {
                                          if(keyColumn == 'value_delivery_time_grouped'){
                                            html = html + '<td>' + $scope.additionals['formatTime'](item[keyColumn]) + '</td>';
                                          } else {
                                            html = html + '<td>' + item[keyColumn] + '</td>';
                                          }
                                        }
                                    } else {
                                        html = html + '<td></td>';
                                    }
                                }
                            }
                        });
                        html = html + '</tr>';

                        nos_orders = nos_orders + parseInt(item['nos_orders']);
                        nos_slots = nos_slots + parseInt(item['nos_slots']);
                        values_orders = values_orders + parseFloat(item['values_orders']);
                        shipping_values_orders = shipping_values_orders + parseFloat(item['shipping_values_orders']);
                        discount_values_orders = discount_values_orders + parseFloat(item['discount_values_orders']);

                        shipping_no_orders_1 = shipping_no_orders_1 + parseFloat(item['shipping_no_orders_1']);
                        shipping_no_orders_2 = shipping_no_orders_2 + parseFloat(item['shipping_no_orders_2']);
                        shipping_value_orders_1 = shipping_value_orders_1 + parseFloat(item['shipping_value_orders_1']);
                        shipping_value_orders_2 = shipping_value_orders_2 + parseFloat(item['shipping_value_orders_2']);

                        if (!angular.isUndefined($scope.order_source)){
                        angular.forEach($scope.order_source.options, function (itemSource, indexSource) {
                          if(indexSource != '' && itemSource['id'] != 3){
                              if (angular.isUndefined(itemSource['source_no_orders_'+itemSource.id])) {
                                itemSource['source_no_orders_'+itemSource.id] = 0;
                              }
                              if (angular.isUndefined(itemSource['source_value_orders_'+itemSource.id])) {
                                itemSource['source_value_orders_'+itemSource.id] = 0;
                              }

                              window['source_no_orders_'+itemSource.id] = window['source_no_orders_'+itemSource.id] + parseFloat(item['source_no_orders_'+itemSource.id]);

                             window['source_value_orders_'+itemSource.id] = window['source_value_orders_'+itemSource.id] + parseFloat(item['source_value_orders_'+itemSource.id]);
                           }
                        });
                      }

                        if (!angular.isUndefined($scope.discounts)){
                        angular.forEach($scope.discounts, function (itemDiscount, indexDiscount) {
                            if (angular.isUndefined(itemDiscount['discount_no_orders_'+itemDiscount.id])) {
                              itemDiscount['discount_no_orders_'+itemDiscount.id] = 0;
                            }
                            if (angular.isUndefined(itemDiscount['discount_value_orders_'+itemDiscount.id])) {
                              itemDiscount['discount_value_orders_'+itemDiscount.id] = 0;
                            }

                           window['discount_no_orders_'+itemDiscount.id] = window['discount_no_orders_'+itemDiscount.id] + parseFloat(item['discount_no_orders_'+itemDiscount.id]);

                           window['discount_value_orders_'+itemDiscount.id] = window['discount_value_orders_'+itemDiscount.id] + parseFloat(item['discount_value_orders_'+itemDiscount.id]);
                        });
                      }

                    });

                    html = html + '<tr>';
                    html = html + '<td>Total</td>';
                    angular.forEach(printColumns, function (itemColumn, keyColumn) {
                        if(!itemColumn['nonDisplay']) {
                            if (keyColumn == 'order_numbers') {
                                html = html + '<td class="align-right total">' + order_numbers + '</td>';
                            } else if (keyColumn == 'nos_orders') {
                                html = html + '<td class="align-right total">' + nos_orders + '</td>';
                            } else if (keyColumn == 'nos_slots') {
                                html = html + '<td class="align-right total">' + nos_slots + '</td>';
                            } else if (keyColumn == 'values_orders') {
                                html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](values_orders) + '</td>';
                            } else if (keyColumn == 'shipping_values_orders') {
                                html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](shipping_values_orders) + '</td>';
                            } else if (keyColumn == 'discount_values_orders') {
                                html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](discount_values_orders) + '</td>';
                            } else if (keyColumn == 'shipping_no_orders_1') {
                                html = html + '<td class="align-right total">' + shipping_no_orders_1 + '</td>';
                            } else if (keyColumn == 'shipping_no_orders_2') {
                                html = html + '<td class="align-right total">' + shipping_no_orders_2 + '</td>';
                            } else if (keyColumn == 'shipping_value_orders_1') {
                                html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](shipping_value_orders_1) + '</td>';
                            } else if (keyColumn == 'shipping_value_orders_2') {
                                html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](shipping_value_orders_2) + '</td>';
                            } else if (keyColumn == 'date') {
                                html = html + '<td></td>';
                            } else if ($scope.search['reportType'] == 'reportStatisticSourceOrder') {
                              if (!angular.isUndefined($scope.order_source)){
                                angular.forEach($scope.order_source.options, function (itemSource, indexSource) {
                                  if(indexSource != '' && itemSource['id'] != 3){
                                   if (keyColumn == 'source_no_orders_'+itemSource.id) {
                                     if(indexSource != '' && itemSource['id'] != 3){
                                       html = html + '<td class="align-right total">' + window['source_no_orders_'+itemSource.id] + '</td>';
                                     }
                                   }
                                   if (keyColumn == 'source_value_orders_'+itemSource.id) {
                                       html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](window['source_value_orders_'+itemSource.id]) + '</td>';
                                   }
                                 }
                              });
                              }
                          } else if ($scope.search['reportType'] == 'reportStatisticDiscountOrder') {
                              if (!angular.isUndefined($scope.discounts)){
                                angular.forEach($scope.discounts, function (itemDiscount, indexDiscount) {
                                 if (keyColumn == 'discount_no_orders_'+itemDiscount.id) {
                                    html = html + '<td class="align-right total">' + window['discount_no_orders_'+itemDiscount.id] + '</td>';
                                 }
                                 if (keyColumn == 'discount_value_orders_'+itemDiscount.id) {
                                     html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](window['discount_value_orders_'+itemDiscount.id]) + '</td>';
                                 }
                              });
                              }
                            } else {
                                html = html + '<td></td>';
                            }
                        }

                    });
                    html = html + '</tr>';

                    html = html + '</table>';
                }

                popup.document.write('<!DOCTYPE html><html><head><title>'+ title +'</title>'
                    + '<link rel="stylesheet" type="text/css" href="/css/print-preview.css" />'
                    + '</head><body onload="window.print(); window.close();">'
                    + html
                    + '</body></html>');
                //popup.document.close();

            }).error(function (data) {
            $scope.isLoadingPagination = false;
            $scope.errors = data.errors;
        });

    }

    $scope.cancelSearchReport = function (ev, path, reportType) {
        $scope.search.dateFrom = '';
        $scope.search.dateTo = '';

        if($scope.searchControl == true) {
            $scope.getPaginateModel(path, 1, $scope.defaultItem);
        }
        angular.element(document.querySelector('.expand-collapse-content')).slideToggle('200',function() {
            angular.element(document.querySelector('#collapse i')).toggleClass('fa-minus fa-plus');
        });
        angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
        angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
        angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
        angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
        var form = document.getElementById('search-form');
        form.reset();

        $timeout($scope.removeDate, 500);

    }

    if($location.path() == $scope.path+'/reportStatisticTotalOrder') {
        $scope.search.period = 'daily';
        $scope.columns = {
            'date':{'label':'Data', 'filter':1, 'filterType':'input'},
            'nos_orders':{'label':'Nr. comenzi', 'filter':1, 'filterType':'input'},
            'nos_slots':{'label':'Nr. sloturi', 'filter':1, 'filterType':'input'},
            'shipping_values_orders':{'label':'Total valoare livrare ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
            'discount_values_orders':{'label':'Total valoare discounturi ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
            'values_orders':{'label':'Total valoare comenzi ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
        };
        $scope.search['reportType'] = 'reportStatisticTotalOrder';
        $scope.additionals['reportType'] = 'reportStatisticTotalOrder';
        $scope.title = 'Comenzi / Statistici zilnice/lunare';
        $scope.classAction = 'td-small';
    }

    if($location.path() == $scope.path+'/reportStatisticShippingOrder') {
        $scope.search.period = 'daily';
        $scope.columns = {
            'date':{'label':'Data/Luna', 'filter':1, 'filterType':'input'},
            'shipping_no_orders_1':{'label':'Nr. comenzi cu livrare la domiciliu', 'filter':1, 'filterType':'input'},
            'shipping_no_orders_2':{'label':'Nr. comenzi cu ridicare', 'filter':1, 'filterType':'input'},
            'shipping_no_orders_3':{'label':'Nr. comenzi cu servire', 'filter':1, 'filterType':'input'},
            'shipping_no_orders_4':{'label':'Nr. comenzi personal', 'filter':1, 'filterType':'input'},

            'shipping_value_orders_1':{'label':'Valoare comenzi cu livrare la domiciliu('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
            'shipping_value_orders_2':{'label':'Valoare comenzi cu ridicare ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
            'shipping_value_orders_3':{'label':'Valoare comenzi cu servire ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
            'shipping_value_orders_4':{'label':'Valoare comenzi personal ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},


            'values_orders':{'label':'Total valoare comenzi ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
        };
        $scope.search['reportType'] = 'reportStatisticShippingOrder';
        $scope.additionals['reportType'] = 'reportStatisticShippingOrder';
        $scope.title = 'Comenzi / Statistici zilnice/lunare';
        $scope.classAction = 'td-small';

    }

    if($location.path() == $scope.path+'/reportStatisticSourceOrder') {
        $scope.order_source = {};
        $scope.order_source.options = [
            {'id': '', 'value' : ''},
            {'id': 0, 'value': 'Directa', 'icon': $scope.additionals['publicAppPath'] + '/direct.png'},
            {'id': 1, 'value': 'Telefon', 'icon' : $scope.additionals['publicAppPath']+'/phone.png'},
            {'id': 2, 'value':  $rootScope.nameProject, 'icon' : $scope.additionals['publicAppPath']+'/logo_ssmall.png'},
            {'id': 3, 'value': 'HipMenu', 'icon' : $scope.additionals['publicAppPath']+'/hipmenu.png'},
            {'id': 4, 'value': 'FoodPanda', 'icon' : $scope.additionals['publicAppPath']+'/foodpanda.png'},
            {'id': 5, 'value': 'Tazz', 'icon': $scope.additionals['publicAppPath'] + '/tazz.png'},
            {'id': 6, 'value': 'Glovo', 'icon': $scope.additionals['publicAppPath'] + '/glovo.png'},
            {'id': 7, 'value': 'Takeaway', 'icon': $scope.additionals['publicAppPath'] + '/takeaway.png'}
        ];
        $scope.search.period = 'daily';
        $scope.columns = {};
        $scope.columns['date'] = {'label':'Data/Luna', 'filter':1, 'filterType':'input'};
        angular.forEach($scope.order_source.options, function (item, index) {
            if(index != '' && item['id'] != 3){
                 $scope.columns['source_no_orders_'+item['id']] = {'label':'Nr. comenzi '+ item['value'], 'filter':1, 'filterType':'input'};
                 $scope.columns['source_value_orders_'+item['id']] = {'label':'Valoare comenzi '+ item['value'], 'filter':1, 'filterType':'input'};
            }
        });
        $scope.columns['values_orders'] = {'label':'Total valoare comenzi ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'};

        $scope.search['reportType'] = 'reportStatisticSourceOrder';
        $scope.additionals['reportType'] = 'reportStatisticSourceOrder';
        $scope.title = 'Comenzi / Statistici zilnice/lunare';
        $scope.classAction = 'td-small';
    }

    if($location.path() == $scope.path+'/reportStatisticDiscountOrder') {
        //discount_id - 0 for discount products, 1 for client discount, 2 loyalty point discount, 3 order discount;
        $scope.discounts = [
            {'id' : 0, 'value' : 'Reducere produs'},
            {'id' : 3, 'value' : 'Reducere comanda'},
            {'id' : 4, 'value' : 'Reducere Tazz'},
            {'id' : 1, 'value' : 'Reducere client'},
            {'id' : 2, 'value' : 'Reducere pct. fidelizare'}
        ];
        $scope.search.period = 'daily';
        $scope.columns = {};
        $scope.columns['date'] = {'label':'Data/Luna', 'filter':1, 'filterType':'input'};
        angular.forEach($scope.discounts, function (item, index) {
            $scope.columns['discount_no_orders_'+item['id']] = {'label':'Nr. comenzi '+ item['value'], 'filter':1, 'filterType':'input'};
            $scope.columns['discount_value_orders_'+item['id']] = {'label':'Valoare comenzi '+ item['value'], 'filter':1, 'filterType':'input'};
        });
        $scope.columns['values_orders'] = {'label':'Total valoare comenzi ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'};

        $scope.search['reportType'] = 'reportStatisticDiscountOrder';
        $scope.additionals['reportType'] = 'reportStatisticDiscountOrder';
        $scope.title = 'Comenzi / Statistici zilnice/lunare';
        $scope.classAction = 'td-small';
    }

    if($location.path() == $scope.path+'/reportStatisticDeliveryTimeDriver') {
        $scope.search.period = 'daily';
        $scope.columns = {
            'date':{'label':'Data/Luna', 'filter':1, 'filterType':'input'},
            'drivers':{'label':'Soferi/Timp mediu de livrare per sofer', 'filter':1, 'filterType':'input'},
            'value_delivery_time_grouped':{'label':'Timp mediu de livrare per zi/luna', 'filter':1, 'filterType':'input'}
        };
        $scope.search['reportType'] = 'reportStatisticDeliveryTimeDriver';
        $scope.additionals['reportType'] = 'reportStatisticDeliveryTimeDriver';
        $scope.title = 'Comenzi / Statistici zilnice/lunare';
        $scope.classAction = 'td-small';

        /* get drivers */
        $scope.additionals['searchTermDriverSingle'];
        $scope.additionals['clearSearchTermDriverSingle'] = function() {
            $scope.additionals['searchTermDriverSingle'] = '';
        };
        $scope.additionals['onSearchChangeDriverSingle'] = function(ev) {
            ev.stopPropagation();
        };
        $scope.getDrivers = function () {
            Crud.get($scope.path + '/getDrivers')
                .success(function (data) {
                    if (angular.isUndefined($scope.additionals['drivers'])) {
                        $scope.additionals['drivers'] = [];
                    }
                    $scope.additionals['driversAll'] = data.drivers;

                });
        }
        $scope.getDrivers();
    }


	}]
)
